import { render } from "./LimitedItemList.vue?vue&type=template&id=249ef7e3&scoped=true"
import script from "./LimitedItemList.vue?vue&type=script&lang=js"
export * from "./LimitedItemList.vue?vue&type=script&lang=js"

import "./LimitedItemList.vue?vue&type=style&index=0&id=249ef7e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249ef7e3"]])

export default __exports__